import { wobaText } from "@/dashboard/components/dashboard-ds";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";
import { useTranslation } from "react-i18next";
import { ActionExportReportInsights } from "./components/action-export-report-insights";

/** Cabeçalho do Painel: título, subtítulo e "Gerar relatório" (Figma 6036:3290). */
export const DashboardHeaderActions = () => {
  const [translate] = useTranslation(["dashboard"]);
  const { filters } = useDashboardFilters();

  return (
    <header
      className="flex flex-col gap-4 items-stretch md:flex-row md:items-center"
      data-testid="dashboard-header"
    >
      <div className="flex flex-col flex-1 gap-1 min-w-0">
        <h1 style={wobaText.headingLarge}>{translate("dashboard-title")}</h1>
        <p style={wobaText.captionMedium}>
          {translate("dashboard-description")}
        </p>
      </div>

      <ActionExportReportInsights filters={filters} />
    </header>
  );
};
